module.exports = "https://redage.akamaized.net/src/views/player/menu/elements/fractions/elements/tasks/images/5.png";